import { I18nContext } from "components/I18N";
import { useContext, useEffect, useRef, useState } from "react";
import {
  SwiperButtonNext,
  SwiperButtonPrev,
} from "components/home/Testimonial";
import { SwiperSlide, Swiper } from "swiper/react";
import { Pagination, Navigation } from "swiper";

let _calculatedWidth = null;
let _calculateLeft = null;

const CheckReviewBox = (props) => {
  const { itemBuilder } = props;
  const containerRef = useRef();
  const [rect, setRect] = useState();

  useEffect(() => {
    setRect(null);
    setTimeout(() => {
      const rect = containerRef.current?.getBoundingClientRect();
      setRect(rect);
    }, 350);

    // console.log(props.isActive, rect)
    // console.log(containerRef.current);
  }, [JSON.stringify(props)]);

  const _expanded = props.isActive && rect && !props.isDuplicate;

  if (_expanded && (!_calculatedWidth || !_calculateLeft)) {
    _calculatedWidth = `${rect.x + rect.width - 10}px`;
    _calculateLeft = `-${rect.x - 10}px`;
  }

  let _width = _calculatedWidth || "100%";
  let _left = props.isActive ? _calculateLeft || 0 : 0;

  return (
    <div id={props.id} ref={containerRef} className="relative">
      <div
        className="review-box-parent opacity-100 md:opacity-0"
        style={{
          position: "absolute",
          width: _width,
          height: "100%",
          left: _left,
          top: 0,
        }}
      >
        {itemBuilder(props)}
        {/* <ReviewBox
          item={props.item}
          isActive={props.isActive}
        /> */}
      </div>
      <div className="opacity-0 md:opacity-100 pointer-events-none	md:pointer-events-auto">
        {itemBuilder(props)}
        {/* <ReviewBox
          item={props.item}
          isActive={props.isActive}
        /> */}
      </div>
    </div>
  );
};

const ReviewSection = ({
  data = [],
  backgroundColor = "#F7F5F1",
  itemBuilder,
  swiperConfigs = {},
  overlayTitle = false,
}) => {
  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);

  const _swiperConfigs = {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      641: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    modules: [Pagination, Navigation],
    className: "mySwiper",
    centeredSlides: true,
    loopFillGroupWithBlank: true,
    loop: true,
    useSwiper: true,
    observer: true,
    observeParents: true,
    ...swiperConfigs,
  };

  return (
    <div
      className="py-[80px] container-wrapper overflow-x-hidden review-section"
      style={{ backgroundColor }}
    >
      {!overlayTitle && (
        <h2 className="heading6 font-bold mb-8 text-left	md:text-center">
          {I18n.get("reviewTitle")}
        </h2>
      )}
      <Swiper {..._swiperConfigs}>
        {data.map((item, i) => {
          return (
            <SwiperSlide key={i}>
              {(props) => {
                return (
                  <CheckReviewBox
                    key={new Date().getTime()}
                    id={new Date().getTime()}
                    item={item}
                    itemBuilder={itemBuilder}
                    {...props}
                  />
                );
              }}
            </SwiperSlide>
          );
        })}

        {/* <div className="flex space-x-[16px] mt-0 md:mt-[32px] md:justify-center justify-start">
          <SwiperButtonPrev />
          <SwiperButtonNext />
        </div> */}

        <div
          className={
            (swiperConfigs?.className || "").includes("hair-review")
              ? "block md:absolute md:top-0 md:right-0 mt-[24px] md:mt-0 z-[999]"
              : "absolute bottom-[24px] mt-0  md:static md:mt-[32px] md:bottom-0 z-[999]"
          }
        >
          <div className="flex space-x-[16px] md:justify-center justify-start">
            <SwiperButtonPrev />
            <SwiperButtonNext />
          </div>
        </div>

        {overlayTitle && (
          <div className="absolute left-0 top-0 mt-[8px]">
            <p className="heading6 font-bold text-left	md:text-center">
              {I18n.get("reviewTitle")}
            </p>
          </div>
        )}
      </Swiper>
    </div>
  );
};

export default ReviewSection;
